var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActiveUserExpireLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25709_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 8.00016H7.50016C7.50016 8.21538 7.63788 8.40645 7.84205 8.4745L8.00016 8.00016ZM8.50016 4.66683C8.50016 4.39069 8.2763 4.16683 8.00016 4.16683C7.72402 4.16683 7.50016 4.39069 7.50016 4.66683H8.00016H8.50016ZM9.84205 9.14117C10.104 9.2285 10.3872 9.08692 10.4745 8.82494C10.5618 8.56297 10.4202 8.27981 10.1583 8.19249L10.0002 8.66683L9.84205 9.14117ZM8.00016 8.00016H8.50016V4.66683H8.00016H7.50016V8.00016H8.00016ZM8.00016 8.00016L7.84205 8.4745L9.84205 9.14117L10.0002 8.66683L10.1583 8.19249L8.15827 7.52582L8.00016 8.00016ZM14.6668 8.00016H14.1668C14.1668 11.4059 11.4059 14.1668 8.00016 14.1668V14.6668V15.1668C11.9582 15.1668 15.1668 11.9582 15.1668 8.00016H14.6668ZM8.00016 14.6668V14.1668C4.59441 14.1668 1.8335 11.4059 1.8335 8.00016H1.3335H0.833496C0.833496 11.9582 4.04212 15.1668 8.00016 15.1668V14.6668ZM1.3335 8.00016H1.8335C1.8335 4.59441 4.59441 1.8335 8.00016 1.8335V1.3335V0.833496C4.04212 0.833496 0.833496 4.04212 0.833496 8.00016H1.3335ZM8.00016 1.3335V1.8335C11.4059 1.8335 14.1668 4.59441 14.1668 8.00016H14.6668H15.1668C15.1668 4.04212 11.9582 0.833496 8.00016 0.833496V1.3335Z",
    fill: "#181D27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25709_1661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActiveUserExpireLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/active_user_expire_link.db915a819f948fdd3d1ee2d39cfd2abf.svg";